import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import {IUserDto, IUserInfo, IUserRegistrartionSteps} from "redux/users/types";
import RoutesValidate from "./RoutesValidate";
import { Welcome, ServiceAgreement, Loader, StartPage, SellerNew } from "pages";
import {ICurrentSeller, ISellerData} from "redux/sellers/types";

interface IAllRoutes {
  isAllSellersLoaded: boolean;
  isCurrentSellerSetted: boolean;
  currentUserLoaded: boolean;
  registrationSteps: {
    data: IUserRegistrartionSteps
  } | null;
  currentSeller: ISellerData|null;
  currentUserData: IUserDto|null;
  allSellers: Array<ISellerData>;
}

const AllRoutes: React.FC<IAllRoutes> = React.memo(
  ({ isAllSellersLoaded, isCurrentSellerSetted, currentUserLoaded, registrationSteps, currentSeller, currentUserData, allSellers }) => {
    return (
      <>
        {currentUserLoaded && registrationSteps && registrationSteps.data && isAllSellersLoaded && (
          <Routes>
            <Route
              path="/welcome"
              element={
                !registrationSteps.data.completeRegistration ? (
                  <Welcome />
                ) : !registrationSteps.data.acceptServiceAgreement ? (
                  <Navigate to="/welcome/service-agreement" />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            <Route
              path="/welcome/service-agreement"
              element={
                !registrationSteps.data.completeRegistration ? (
                  <Navigate to="/welcome" />
                ) : !registrationSteps.data.acceptServiceAgreement ? (
                  <ServiceAgreement />
                ) : (
                  <ServiceAgreement />
                )
              }
            />
            <Route
                path="/seller/new"
                element={<SellerNew />}
            />
            <Route
              path="*"
              element={
                allSellers?.length > 0 ? (
                  <RoutesValidate
                    userRegistrationComplete={
                      registrationSteps.data.completeRegistration
                    }
                    isCurrentSellerSetted={isCurrentSellerSetted}
                    userAgreementAcceptComplete={
                      registrationSteps.data.acceptServiceAgreement
                    }
                    currentSeller={currentSeller}
                    currentUserData={currentUserData}
                  />
                ) : (
                  <StartPage />
                )
              }
            />
          </Routes>
        )}
      </>
    );
  }
);

export default AllRoutes;
